import Details from './Details';

document.addEventListener('DOMContentLoaded', () => {
  const createInstances = (selector, options = {}) => {
    const $elements = document.querySelectorAll(selector);
    return Array.from($elements).map(($el) => ({
      el: $el,
      instance: new Details($el, options),
      mounted: false,
    }));
  };

  const mountInstances = (instances) => {
    instances.forEach((item) => {
      if (!item.mounted) {
        item.instance.mount();
        item.mounted = true;

        const control = item.el.querySelector('.c-details__control');
        if (control && control.tagName !== 'BUTTON') {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = control.className;
          button.innerHTML = control.innerHTML;
          control.replaceWith(button);
        }
      }
    });
  };

  const unmountInstances = (instances) => {
    instances.forEach((item) => {
      if (item.mounted && typeof item.instance.unmount === 'function') {
        item.instance.unmount();
        item.mounted = false;

        const control = item.el.querySelector('.c-details__control');
        if (control && control.tagName === 'BUTTON') {
          const div = document.createElement('div');
          div.className = control.className;
          div.innerHTML = control.innerHTML;
          control.replaceWith(div);
        }
      }
    });
  };

  const detailsInstances = createInstances('.js-details', {
    hasAdditionalControl: true,
  });
  mountInstances(detailsInstances);

  const filterInstances = createInstances('.js-filter', {
    includeMarker: false,
  });

  const checkWindowWidth = () => {
    if (window.innerWidth <= 960) {
      mountInstances(filterInstances);
    } else {
      unmountInstances(filterInstances);
    }
  };

  checkWindowWidth();
  window.addEventListener('resize', checkWindowWidth);
});
